import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/my/',
    component:layout,
    children:[
		{name: '我的', path: 'index', component: ()=>_import('index')},
		{name: '我的保单', path: 'insureList', component: ()=>_import('insureList')},
		{name: '保单详情', path: 'insureDetail', component: ()=>_import('insureDetail')},
		{name: '理赔记录', path: 'createClaim', component: ()=>_import('createClaim')},
		{name: '申请理赔', path: 'claimRecord', component: ()=>_import('claimRecord')},
		{name: '理赔详情', path: 'claimDetail', component: ()=>_import('claimDetail')},
		{name: '我的团队', path: 'team', component: ()=>_import('team')},
		{name: '上级团队', path: 'superiorTeam', component: ()=>_import('superiorTeam')},
		{name: '关于我们', path: 'searchInsure', component: ()=>_import('searchInsure')},
		{name: '发票记录', path: 'invoiceRecord', component: ()=>_import('invoiceRecord')},
        // add route here
    ]
}